export default "__VITE_ASSET__D5mXG1gZ__"